import React from "react";
import { createAuction } from "../../../../../models/auctions";
import { getAllMasks } from "../../../../../models/masks";
import { getAllGroups, getGroup } from "../../../../../models/groups";
import swal from "sweetalert";
import i18n from "../../../../../i18n";
import { Map } from "../../../../helpers/map";
import { getDepartments } from "../../../../../models/departments";
import { getLocations } from "../../../../../models/locations";
import { getAllDivisions } from "../../../../../models/subdivision";
import { Loader2 } from "lucide-react";

const lng = localStorage.getItem("I18N_LANGUAGE");

export class CreateAuctionGeneral extends React.Component {
  constructor() {
    super();
    this.state = {
      lat: 23.588,
      lng: 58.3829,
      input: {
        is_extra_time: false,
        is_featured: true,
        is_zakath: false,
        auto_approval: false,
        is_vat_included: false,
        is_service_charge_included: false,
        is_service_charge_vat_included: false,
      },
      tempArray: {},
      errors: {},
      masks: {},
      groups: [],
      departments: [],
      divisions: [],
      locations: [],
      categories: {},
      organizations: {},
      enquiries: [{ label: "", value: "" }],
      jsonLabel: "",
      jsonValue: "",
      categoryList: "",
      places: [],
      isSubmitting: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.toggleZakath = this.toggleZakath.bind(this);
    this.toggleFeatured = this.toggleFeatured.bind(this);
    this.toggleAutoApproval = this.toggleAutoApproval.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let input = this.state.input;
    input.category = this.props.category;
    input.organization = this.props.organization;
    this.loadAllMasks();
    this.loadAllGroups();
    this.loadAllDeps();
    this.loadAllLocs();
    this.loadAllDivs();
  }

  async loadAllMasks() {
    const response = await getAllMasks();
    let masks = response.data;
    this.setState({ masks });
  }

  async loadAllGroups() {
    const response = await getAllGroups();
    let groups = response.data;
    this.setState({ groups });
  }

  async loadAllDeps() {
    const response = await getDepartments();
    let departments = response.data;
    this.setState({ departments });
  }

  async loadAllDivs() {
    const response = await getAllDivisions();
    let divisions = response.data;
    this.setState({ divisions });
  }

  async loadAllLocs() {
    const response = await getLocations();
    let locations = response.data;
    this.setState({ locations });
  }

  async getGroup(id) {
    const response = await getGroup(id);
    let group = response.data;
    let input = this.state.input;
    input.start_date = group.start_date;
    input.end_date = group.end_date;
    input.reg_start_date = group.reg_start_date;
    input.reg_end_date = group.reg_end_date;
    input.description = group.description;
    input.description_ar = group.description_ar;
    input.payment_type = group.payment_type;
    input.payment_amount = group.amount;
    input.is_extra_time = group.is_extra_time;
    input.extra_time = group.extra_time;
    input.has_auto_bidding = group.has_auto_bidding;
    input.is_vat_included = group.is_vat_included;
    input.is_service_charge_included = group.is_service_charge_included;
    input.is_service_charge_vat_included = group.is_service_charge_vat_included;
    this.setState({ input });
  }

  handleChange(event) {
    let { input, locations } = this.state;
    input[event.target.name] = event.target.value;
    if (event.target.name === "guarantee_amount") {
      input["payment_amount"] = event.target.value;
    }
    this.setState({ input });
    if (event.target.name === "group") {
      this.getGroup(event.target.value);
    }
    if (event.target.name === "location_id") {
      const loc = locations.find(
        (location) => Number(location.id) === Number(event.target.value)
      );
      input.location = loc.name;
      input.location_ar = loc.name_ar;
      input.latitude = loc.latitude;
      input.longitude = loc.longitude;
      this.setState({ input, lat: loc.latitude, lng: loc.longitude });
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, "/")) : null;
  }

  toggleChange = () => {
    let input = this.state.input;
    input.is_extra_time = !this.state.input.is_extra_time;
    this.setState({ input });
  };

  toggleZakath = () => {
    let input = this.state.input;
    input.is_zakath = !this.state.input.is_zakath;
    this.setState({ input });
  };

  toggleFeatured = () => {
    let input = this.state.input;
    input.is_featured = !this.state.input.is_featured;
    this.setState({ input });
  };

  toggleAutoApproval = () => {
    let input = this.state.input;
    input.auto_approval = !this.state.input.auto_approval;
    this.setState({ input });
  };

  handleSelect = (selectedOption) => {
    let updateExtraTime = "";
    const checkCategory = (obj) => obj.label === "phoneNumber";
    if (!selectedOption.some(checkCategory)) {
      updateExtraTime = true;
    }
    const categoryArr = selectedOption.map((opt) => opt.value);
    let input = this.state.input;
    input.is_extra_time = updateExtraTime;
    this.setState({ categoryList: categoryArr, input });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ isSubmitting: true });
      let payload = this.state.input;
      payload.enquiries = this.state.enquiries;
      payload.categories = this.state.categoryList;
      payload.category = this.props.category;
      payload.organization = this.props.organization;
      payload.latitude = this.state.lat;
      payload.longitude = this.state.lng;
      const response = await createAuction(payload);
      if (response && response.data && response.success) {
        swal(i18n.t("success"), response.message, "success");
        setTimeout(() => {
          window.location.href = "/auction/image/" + response.data.id;
        }, 3000);
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  getLocation(lat, lng) {
    this.setState({ lat: lat, lng: lng });
  }

  render() {
    let { groups, departments, locations, divisions } = this.state;
    return (
      <React.Fragment>
        <div className="form-content">
          {/* LEFT COLUMN */}
          <div className="left-column">
            {/* Auction Setup */}
            <div className="form-section">
              <h2>{i18n.t("auction_details")}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("auction_group")}</label>
                  <select
                    name="group"
                    value={this.state.input.group}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t("group")}--</option>
                    {groups &&
                      groups.length > 0 &&
                      groups.map((item) => (
                        <option value={item.id} key={item.id}>
                          {lng === "ar" ? item?.group_name_ar : item.group_name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="form-field">
                  <label>{i18n.t("department")}</label>
                  <select
                    name="department_id"
                    value={this.state.input.department_id}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t("department")}--</option>
                    {departments &&
                      departments.length > 0 &&
                      departments.map((item) => (
                        <option value={item.id} key={item.id}>
                          {lng === "ar" ? item.name_ar : item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("location")}</label>
                  <select
                    name="location_id"
                    value={this.state.input.location_id}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t("location")}--</option>
                    {locations &&
                      locations.length > 0 &&
                      locations.map((item) => (
                        <option value={item.id} key={item.id}>
                          {lng === "ar" ? item.name_ar : item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="form-field">
                  <label>{i18n.t("sub_divisions")}</label>
                  <select
                    name="sub_division_id"
                    value={this.state.input.sub_division_id}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t("sub_divisions")}--</option>
                    {divisions &&
                      divisions.length > 0 &&
                      divisions.map((item) => (
                        <option value={item.id} key={item.id}>
                          {lng === "ar" ? item.name_ar : item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("contract_number")}</label>
                  <input
                    type="text"
                    name="contract_number"
                    placeholder={i18n.t("contract_number")}
                    value={this.state.input.contract_number}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t("payment_type")}</label>
                  <select
                    name="payment_type"
                    value={this.state.input.payment_type}
                    onChange={this.handleChange}
                  >
                    <option value="">--Select--</option>
                    <option value="Online">{i18n.t("online")}</option>
                    <option value="Offline">{i18n.t("offline")}</option>
                    <option value="Both">
                      {i18n.t("online")}+{i18n.t("offline")}
                    </option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("title")} *</label>
                  <input
                    type="text"
                    required={true}
                    name="title"
                    placeholder={i18n.t("title")}
                    value={this.state.input.title}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t("title_ar")} *</label>
                  <input
                    type="text"
                    required={true}
                    name="title_ar"
                    placeholder={i18n.t("title_ar")}
                    value={this.state.input.title_ar}
                    onChange={this.handleChange}
                    dir="rtl"
                  />
                </div>
              </div>
            </div>

            {/* Dates */}
            <div className="form-section">
              <h2>{i18n.t("dates") || "Dates"}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>
                    {i18n.t("start_date")}{" "}
                    {this.state.input.start_date
                      ? "(" + this.state.input.start_date + ")"
                      : ""}
                  </label>
                  <input
                    type="datetime-local"
                    name="start_date"
                    value={this.state.input.start_date}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>
                    {i18n.t("end_date")}{" "}
                    {this.state.input.end_date
                      ? "(" + this.state.input.end_date + ")"
                      : ""}
                  </label>
                  <input
                    type="datetime-local"
                    name="end_date"
                    value={this.state.input.end_date}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>
                    {i18n.t("reg_start_date")}{" "}
                    {this.state.input.reg_start_date
                      ? "(" + this.state.input.reg_start_date + ")"
                      : ""}
                  </label>
                  <input
                    type="datetime-local"
                    name="reg_start_date"
                    value={this.state.input.reg_start_date}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>
                    {i18n.t("reg_end_date")}{" "}
                    {this.state.input.reg_end_date
                      ? "(" + this.state.input.reg_end_date + ")"
                      : ""}
                  </label>
                  <input
                    type="datetime-local"
                    name="reg_end_date"
                    value={this.state.input.reg_end_date}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Description  */}
            <div className="form-section">
              <h2>{i18n.t("description")}</h2>
              <div className="form-field" style={{ marginBottom: "16px" }}>
                <label>{i18n.t("description")} *</label>
                <textarea
                  name="description"
                  placeholder={i18n.t("description")}
                  value={this.state.input.description}
                  onChange={this.handleChange}
                  rows={6}
                  style={{ width: "100%" }}
                ></textarea>
              </div>
              <div className="form-field" style={{ marginBottom: "16px" }}>
                <label>{i18n.t("description")} ({i18n.t("arabic") || "Arabic"}) *</label>
                <textarea
                  name="description_ar"
                  placeholder={i18n.t("description")}
                  value={this.state.input.description_ar}
                  onChange={this.handleChange}
                  style={{ direction: "rtl", width: "100%" }}
                  rows={6}
                ></textarea>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="right-column">
            {/* Financial Details */}
            <div className="form-section">
              <h2>{i18n.t("financial_details") || "Financial Details"}</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("price")}</label>
                  <input
                    type="text"
                    name="start_amount"
                    placeholder={i18n.t("price")}
                    value={this.state.input.start_amount}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t("gurantee_amount")}</label>
                  <input
                    type="text"
                    name="guarantee_amount"
                    placeholder={i18n.t("gurantee_amount")}
                    value={this.state.input.guarantee_amount}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("target_amount")}</label>
                  <input
                    type="text"
                    name="target_amount"
                    placeholder={i18n.t("target_amount")}
                    value={this.state.input.target_amount}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t("visit_amount")}</label>
                  <input
                    type="text"
                    name="visit_amount"
                    placeholder={i18n.t("visit_amount")}
                    value={this.state.input.visit_amount}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t("incr_amount")}</label>
                  <input
                    type="text"
                    name="bid_increment"
                    placeholder={i18n.t("incr_amount")}
                    value={this.state.input.bid_increment}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>{i18n.t("incr_amount")} ({i18n.t("csv")})</label>
                  <input
                    type="text"
                    name="increment_numbers"
                    placeholder="eg: 100,200,300..."
                    value={this.state.input.increment_numbers}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Configurations */}
            <div className="form-section">
              <h2>{i18n.t("config_and_uploads") || "Configurations"}</h2>

              <div className="toggle-field">
                <label>{i18n.t("featured")}</label>
                <div
                  className={`toggle ${this.state.input.is_featured ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_featured = !input.is_featured;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t("auto_approval")}</label>
                <div
                  className={`toggle ${this.state.input.auto_approval ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.auto_approval = !input.auto_approval;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t("auto_bidding") || "Auto Bidding"}</label>
                <div
                  className={`toggle ${this.state.input.has_auto_bidding ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.has_auto_bidding = !input.has_auto_bidding;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t("extra_time")}</label>
                <div
                  className={`toggle ${this.state.input.is_extra_time ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_extra_time = !input.is_extra_time;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
              {this.state.input.is_extra_time && (
                <div className="form-field" style={{ marginTop: "16px" }}>
                  <label>{i18n.t("in_minutes")}</label>
                  <input
                    name="extra_time"
                    type="number"
                    value={this.state.input.extra_time}
                    onChange={this.handleChange}
                    placeholder={i18n.t("in_minutes")}
                  />
                </div>
              )}

              <div className="toggle-field">
                <label>{i18n.t("is_vat_included")}</label>
                <div
                  className={`toggle ${this.state.input.is_vat_included ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_vat_included = !input.is_vat_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t("is_service_charge_included")}</label>
                <div
                  className={`toggle ${this.state.input.is_service_charge_included ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_service_charge_included = !input.is_service_charge_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>{i18n.t("is_service_charge_vat_included")}</label>
                <div
                  className={`toggle ${this.state.input.is_service_charge_vat_included ? "active" : ""}`}
                  onClick={() => {
                    let { input } = this.state;
                    input.is_service_charge_vat_included = !input.is_service_charge_vat_included;
                    this.setState({ input });
                  }}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
            </div>

            {/* Location / Map */}
            <div className="form-section">
              <h2>{i18n.t("location")}</h2>
              {this.state.lat && this.state.lng && (
                <Map
                  getLocation={this.getLocation}
                  defaultLocation={{
                    lat: this.state.lat,
                    lng: this.state.lng,
                  }}
                />
              )}
              <div className="form-row" style={{ marginTop: "12px" }}>
                <div className="form-field">
                  <label>Latitude</label>
                  <input
                    type="text"
                    name="latitude"
                    value={this.state.lat}
                    onChange={(event) => {
                      this.setState({ lat: event.target.value });
                    }}
                  />
                </div>
                <div className="form-field">
                  <label>Longitude</label>
                  <input
                    type="text"
                    name="longitude"
                    value={this.state.lng}
                    onChange={(event) => {
                      this.setState({ lng: event.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons-l2 border-top-light">
          <button
            className="button1 button1-gray"
            onClick={() => window.history.back()}
            type="button"
            disabled={this.state.isSubmitting}
          >
            {i18n.t("cancel")}
          </button>
          <button
            className="button1 button1-primary"
            onClick={this.handleSubmit}
            type="button"
            disabled={this.state.isSubmitting}
          >
            {this.state.isSubmitting ? (
              <>
                <Loader2 className="animate-spin" size={18} />
                <span>{i18n.t("save_continue")}</span>
              </>
            ) : (
              <span>{i18n.t("save_continue")}</span>
            )}
          </button>
        </div>
      </React.Fragment>
    );
  }
}